import { trackEvent } from '../../support-and-tracking/analytics-actions';
import { formatOrganizationNumber } from '../../utils';
import styles from './organization-search.module.less';
import Avatar from '../../components/avatar/Avatar';

const SearchResultItem = ({
    name,
    organizationNumber,
    event,
    image,
    handleOrganizationSelection,
    handleClick,
    promoted,
    hideOrgNumber,
}) => {
    const handleSelection = ({ organizationNumber, name, event, handleClick, promoted }) => {
        handleOrganizationSelection({
            value: organizationNumber,
            label: name,
            event,
        });
        if (handleClick) {
            handleClick();
        }
        trackEvent('org', 'register-select', { 'organization-number': organizationNumber, promoted: !!promoted });
    };
    return (
        <li
            role="button"
            className={styles.searchResult}
            onClick={() => {
                handleSelection({ organizationNumber, name, event, handleClick, promoted });
            }}
            tabIndex="0"
            onKeyPress={(e) => {
                if (e.key === 'Enter') {
                    handleSelection({ organizationNumber, name, event, handleClick, promoted });
                }
            }}
            onKeyDown={(e) => {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    if (e.target.nextElementSibling) {
                        e.target.nextElementSibling?.focus();
                    }
                }
                if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    if (e.target.previousElementSibling) {
                        e.target.previousElementSibling?.focus();
                    } else {
                        e.target.parentNode.previousElementSibling?.focus();
                    }
                }
            }}
        >
            {image && <Avatar imageSrc={image} size="sm" className={styles.organizationImage} />}
            <div className={styles.searchResultDescription}>
                <div className={styles.searchResultName}>{name}</div>
                {!hideOrgNumber && (
                    <div className={styles.searchResultOrgNumber}>{formatOrganizationNumber(organizationNumber)}</div>
                )}
            </div>
        </li>
    );
};

export default SearchResultItem;
